console.log("variant-inventory.js loaded");

function updateVariantInventory(variant) {
  console.log("updateVariantInventory", variant);

  if (!variant) return;

  const statusEl = document.querySelector(".variant-inventory-status");
  if (!statusEl) return;

  const productId = statusEl.dataset.productId;
  const script = document.querySelector(`#VariantInventoryData-${productId}`);
  if (!script) return;

  let map = {};
  try {
    map = JSON.parse(script.textContent);
  } catch (e) {
    console.error("JSON parse error", e);
  }

  const entry = map[String(variant.id)] || {};
  const textEl = statusEl.querySelector(".inventory-text");

  // Text aktualisieren
  textEl.textContent =
    entry.text && entry.text.trim() !== ""
      ? entry.text
      : variant.available
      ? "Sofort lieferbar"
      : "Nicht verfügbar";

  // Klassen reset
  statusEl.classList.remove("is-ok", "is-low", "is-oos");

  // Neue Klasse setzen
  if (!variant.available) {
    statusEl.classList.add("is-oos");
  } else if (entry.inventory_quantity <= 2) {
    statusEl.classList.add("is-low");
  } else {
    statusEl.classList.add("is-ok");
  }
}

/* ---- Impact Theme Events ---- */

document.addEventListener("variant:change", function (event) {
  updateVariantInventory(event.detail.variant);
});

document.addEventListener("product:variant-change", function (event) {
  updateVariantInventory(event.detail.variant);
});

document.addEventListener("product:rerender", function (event) {
  if (event.detail?.variant) {
    updateVariantInventory(event.detail.variant);
  }
});

/* Fallback – erste Initialisierung */
document.addEventListener("DOMContentLoaded", function () {
  const firstVariantId = document.querySelector(".variant-inventory-status")?.dataset.variantId;
  if (!firstVariantId) return;

  const productId = document.querySelector(".variant-inventory-status")?.dataset.productId;
  const script = document.querySelector(`#VariantInventoryData-${productId}`);
  if (!script) return;

  let map = JSON.parse(script.textContent);
  const entry = map[firstVariantId];

  if (entry) {
    updateVariantInventory({
      id: firstVariantId,
      available: entry.available
    });
  }
});